import RenameStep from './RenameStep';

export default RenameStep;
